<template>
  <b-row>
    <b-col cols="8">
      {{ file.name }}
    </b-col>
    <b-col cols="4" class="text-right">
      <tabler-icon
        v-if="downloadable && file.url"
        @click="downloadFile(file.url)"
        icon="DownloadIcon"
        size="20"
        class="d-inline-block text-primary cursor-pointer"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      required: true,
    },
    downloadable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getTablerIcon(ext) {
      if (ext === "pdf") {
        return "MessageIcon";
      } else if (ext === "image") {
        return "image";
      } else if (ext === "video") {
        return "play-circle";
      } else if (ext === "audio") {
        return "headphones";
      } else if (ext === "document") {
        return "file";
      } else {
        return "file";
      }
    },
    downloadFile(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style>
</style>